// src/components/LegalPageLayout.tsx
// Közös keret az ÁSZF-hez és az Adatvédelmi nyilatkozathoz: Navbar, Footer, "Vissza" gomb.
import React from "react";
import { Box, Button, Container, Divider, Typography, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface Props {
    title: string;
    updated: string;
    children: React.ReactNode;
}

export const LegalSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
    <Box component="section" sx={{ mb: 4 }}>
        <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            {title}
        </Typography>
        {children}
    </Box>
);

export const LegalText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Typography variant="body1" paragraph sx={{ lineHeight: 1.75 }}>
        {children}
    </Typography>
);

export const LegalList: React.FC<{ items: React.ReactNode[] }> = ({ items }) => (
    <Box component="ul" sx={{ pl: 3, mt: 0, mb: 2 }}>
        {items.map((item, i) => (
            <Typography component="li" variant="body1" key={i} sx={{ lineHeight: 1.75, mb: 0.5 }}>
                {item}
            </Typography>
        ))}
    </Box>
);

const LegalPageLayout: React.FC<Props> = ({ title, updated, children }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();

    // Ha van előző oldal az appon belül, oda lépünk vissza, különben a főoldalra
    const handleBack = () => {
        if (location.key !== "default") {
            navigate(-1);
        } else {
            navigate("/");
        }
    };

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
                bgcolor: theme.palette.mode === "dark" ? theme.palette.background.default : "#fafafa",
            }}
        >
            <Navbar />
            <Container maxWidth="md" sx={{ pt: 12, pb: 6 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={handleBack} sx={{ mb: 2, textTransform: "none" }}>
                    Vissza
                </Button>

                <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Hatályos: {updated}
                </Typography>
                <Divider sx={{ mb: 4 }} />

                {children}

                <Divider sx={{ my: 4 }} />
                <Button startIcon={<ArrowBackIcon />} onClick={handleBack} sx={{ textTransform: "none" }}>
                    Vissza
                </Button>
            </Container>
            <Footer />
        </Box>
    );
};

export default LegalPageLayout;